import React from 'react'
import { useTranslation } from 'react-i18next'
import dialogActions from '../features/dialog/actions'
import Button from '../styleguide/buttons/Button'
import DialogActions from '../styleguide/dialog/DialogActions'
import DialogContent from '../styleguide/dialog/DialogContent'
import DialogContentText from '../styleguide/dialog/DialogContentText'
import { useTeloDispatch } from '../store'
import authActions from '../features/auth/actions'
import appActions from '../features/app/actions'
import { useExamStatusUpdate } from '../hooks/useExamStatusUpdate'

const LogoutDialog = () => {
	const { t } = useTranslation()
	const dispatch = useTeloDispatch()
	const { setStartedExamToWaiting } = useExamStatusUpdate()

	return (
		<>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{t('login.logoutDialogText')}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => dispatch(dialogActions.closeDialog())}
					variant="outlined"
				>
					{t('app.cancel')}
				</Button>
				<Button
					data-testid="ok-quit-logout"
					onClick={() => {
						dispatch(dialogActions.closeDialog())
						setStartedExamToWaiting()
						dispatch(appActions.removeStoreId())
						dispatch(authActions.setAppLoginStatus('logging out'))
					}}
					autoFocus
					variant="contained"
				>
					{t('login.okQuit')}
				</Button>
			</DialogActions>
		</>
	)
}

export default LogoutDialog
